<template>
  <vs-popup id="popupCreate736" title="에너지검토분류표 신규등록" :active.sync="showPopup">
    <div>
      <field-select-module v-model="stdInfo" :board="this.board" :types='["department", "com_name", "rank", "writer_name", "date"]'/>
      <div class="header mb-4 flex ">
        <h5 class="flex items-center"><i class="dot"></i> 에너지검토분류표</h5>
        <div class="flex ml-auto gap-2">
          <button @click="pushRow">
            <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" />
          </button>
          <button @click="popRow">
            <feather-icon icon="MinusIcon" svgClasses="h-5 w-5" />
          </button>
        </div>
      </div>
      <div class="body mb-4">
        <table class="w-full">
          <tbody>
            <tr v-for="data in list">
              <td><field-selector v-model="data.사업장.id" @select="(field)=>{data.사업장.field_name = field.field_name}"/></td>
              <td><ml-input v-model="data.팀명" placeholder="입력"/></td>
              <td><ml-input v-model="data.공장명" placeholder="입력"/></td>
              <td><ml-input v-model="data.공정명" placeholder="입력"/></td>
              <td>
                <vs-select class="w-full" v-model="data.상태" autocomplete>
                  <vs-select-item v-for="상태 in ['정상', '비정상', '비상',]" :text="상태" :value="상태" />
                </vs-select>
              </td>
              <td><ml-input v-model="data.활동명" placeholder="입력"/></td>
            </tr>
          </tbody>
          <thead>
          <tr>
            <th><div>사업장명</div></th>
            <th><div>팀명</div></th>
            <th><div>공장명</div></th>
            <th><div>공정명</div></th>
            <th><div>상태</div></th>
            <th><div>활동명</div></th>
          </tr>
          </thead>
        </table>
      </div>
      <div class="mt-4 flex justify-end gap-2">
        <vs-button color="#DCDFE2" textColor="#000" @click="showPopup = false">닫기</vs-button>
        <vs-button color="secondary" @click="onClickSave">등록</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import FieldSelector from "@/components/selector/FieldSelector.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {FieldSelectModule, FieldSelector},
  props: {
    value: Boolean,
    header: Object,
    board: Object,
  },
  computed:{
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    showPopup: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    pageTitle() {
      return this.$store.state.menu.pageTitle;
    },
  },
  watch: {
    showPopup (showPopup) {
      if (showPopup) {
        this.list = []
      }
    }
  },
  data() {
    return {
      stdInfo: {},
      list: [],
    }
  },
  methods: {
    pushRow () {
      if (this.list.length === 0) {
        this.list.push({
          사업장: {id: 0, field_name: ''},
          팀명: '',
          공장명: '',
          공정명: '',
          상태: '',
          활동명: '',
        })
      } else {
        this.list.push({
          사업장: Object.assign({}, this.list[this.list.length - 1].사업장),
          팀명: this.list[this.list.length - 1].팀명,
          공장명: this.list[this.list.length - 1].공장명,
          공정명: '',
          상태: '',
          활동명: '',
        });
      }

    },
    popRow () {
      this.list.pop()
    },
    onClickSave () {
      this.writeOnClickSaveMultiple({
        posts: this.list.map((data) => {
          return {
            stdInfo: this.stdInfo,
            ...data
          }
        }),
        callback: (result, response) => {
          if (result) {
            this.$emit('save')
            this.showPopup = false;

          }
        },
      });

    },
    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },

    writeOnClickSaveMultiple(forms) {
      const boardId = 893;
      this.loading(true);
      const date = new Date();
      const header = {...this.header, full: date.format("yyyy-MM-dd")};
      const posts = forms.posts.map((form) => {
        const content = {
          header,
          body: {
            ...form
          },
        };
        return {
          title: this.pageTitle,
          content: JSON.stringify(content),
          projectId: this.projectId,
          company_member_join: true,
        }
      });
      HttpRequest.put(`/api/v1/board/post/${boardId}/multiple`, { posts })
        .then((response) => {
          if (forms.callback) {
            forms.callback(true, response);
          }

          this.loading(false);
        })
        .catch(({ response }) => {
          if (forms.callback) {
            forms.callback(false, response);
          }
          this.loading(false);
        });
    },
  }
}
</script>

<style scoped lang="scss">
.body {
  height: 553px;
  overflow-y: scroll;
  border-bottom: 1px solid #cdcdcd;
  background: #FAFAFA;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  min-width: 800px;

  thead {
    position: sticky;
    top: 0;
  }

  th{
    font-weight: bold;
    text-align: center;
    padding: 0;

    & > div {
      padding: 10px 4px;
      border-top: 1px solid #cdcdcd;
      border-bottom: 1px solid #cdcdcd;
    }
  }
  th,
  td {
    background: #F9F9F9;
    border-right: 1px solid #cdcdcd;
    &:last-child {
      border-right: none;
    }
  }

  td {
    padding: 4px;
    border-bottom: 1px solid #cdcdcd;
  }
}

.header {
  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }
}

</style>
